var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.592,
    x2: 259.033,
    xlinkHref: "#lg1",
    y1: 144.926,
    y2: 184.304
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.039,
    x2: 304.039,
    xlinkHref: "#lg2",
    y1: 188.27,
    y2: 251.599
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.204,
    x2: 326.87,
    xlinkHref: "#lg2",
    y1: 166.469,
    y2: 219.108
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.717,
    x2: 346.362,
    xlinkHref: "#lg2",
    y1: 154.378,
    y2: 209.933
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.201,
    x2: 362.154,
    xlinkHref: "#lg2",
    y1: 144.302,
    y2: 185.246
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 0 0 -1 0 -725.383)",
    gradientUnits: "userSpaceOnUse",
    x1: 234.592,
    x2: 259.033,
    xlinkHref: "#lg1",
    y1: -1147.739,
    y2: -1108.361
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(1 0 0 -1 0 -725.383)",
    gradientUnits: "userSpaceOnUse",
    x1: 304.039,
    x2: 304.039,
    xlinkHref: "#lg2",
    y1: -1104.394,
    y2: -1041.066
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 0 0 -1 0 -725.383)",
    gradientUnits: "userSpaceOnUse",
    x1: 324.204,
    x2: 326.87,
    xlinkHref: "#lg2",
    y1: -1126.196,
    y2: -1073.556
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(1 0 0 -1 0 -725.383)",
    gradientUnits: "userSpaceOnUse",
    x1: 347.717,
    x2: 346.362,
    xlinkHref: "#lg2",
    y1: -1138.287,
    y2: -1082.732
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(1 0 0 -1 0 -725.383)",
    gradientUnits: "userSpaceOnUse",
    x1: 364.201,
    x2: 362.154,
    xlinkHref: "#lg2",
    y1: -1148.363,
    y2: -1107.418
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.27,
    x2: 337.355,
    xlinkHref: "#lg1",
    y1: 145.625,
    y2: 323.871
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.925,
    x2: 451.183,
    xlinkHref: "#lg3",
    y1: 240.725,
    y2: 254.984
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.715,
    x2: 287.067,
    xlinkHref: "#lg3",
    y1: 161.248,
    y2: 252.531
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.384,
    x2: 342.443,
    xlinkHref: "#lg2",
    y1: 415.519,
    y2: 330.039
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.53,
    x2: 332.645,
    xlinkHref: "#lg1",
    y1: 271.439,
    y2: 337.654
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.584,
    x2: 348.977,
    xlinkHref: "#lg2",
    y1: 308.413,
    y2: 367.51
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.511,
    x2: 375.849,
    xlinkHref: "#lg2",
    y1: 299.379,
    y2: 348.867
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.473,
    x2: 331.472,
    xlinkHref: "#lg3",
    y1: 283.866,
    y2: 357.197
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.722,
    x2: 323.46,
    xlinkHref: "#lg4",
    y1: 280.363,
    y2: 348.67
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.161,
    x2: 271.496,
    xlinkHref: "#lg5",
    y1: 296.623,
    y2: 376.727
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.827,
    x2: 270.236,
    xlinkHref: "#lg5",
    y1: 294.49,
    y2: 346.178
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.272,
    x2: 78.044,
    xlinkHref: "#lg4",
    y1: 261.953,
    y2: 376.618
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.846,
    x2: -3.056,
    xlinkHref: "#lg5",
    y1: 272.079,
    y2: 333.095
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.958,
    x2: 66.709,
    xlinkHref: "#lg5",
    y1: 280.868,
    y2: 320.234
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.785,
    x2: 78.008,
    xlinkHref: "#lg3",
    y1: 233.331,
    y2: 306.757
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.259,
    x2: 75.326,
    xlinkHref: "#lg3",
    y1: 323.734,
    y2: 367.469
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.152,
    x2: 490.553,
    xlinkHref: "#lg6",
    y1: 140.776,
    y2: 180.176
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.529,
    x2: 502.041,
    xlinkHref: "#lg6",
    y1: 194.145,
    y2: 211.657
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.529,
    x2: 502.041,
    xlinkHref: "#lg6",
    y1: 91.992,
    y2: 109.504
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.132 212.817c-30.111-29.084-70.858-53.479-110.438-53.479-47.146 0-147.523 45.758-206.991 79.855-8.544 4.901-15.509 12.289-20.337 21.151-.88 1.617-1.687 3.284-2.432 5.002-3.285-8.135-5.08-16.907-5.08-25.729 0-10.793 2.693-20.727 7.512-28.882 4.828-8.155 11.793-14.522 20.337-18.16 59.469-25.365 159.845-56.38 206.991-49.457 39.58 5.821 80.327 36.199 110.438 69.699z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.946 192.917 15.347 38.127c60.186-32.796 148.926-71.706 192.401-71.706 39.58 0 80.327 24.395 110.438 53.479-30.111-33.5-70.858-63.878-110.438-69.699-47.146-6.922-147.523 24.092-206.991 49.457-.255.109-.505.228-.757.342z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.677 209.812c54.363-26.299 116.749-50.474 151.017-50.474 39.58 0 80.327 24.395 110.438 53.479-30.111-33.5-70.858-63.878-110.438-69.699-37.159-5.456-107.381 12.655-164.583 32.992z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.694 143.118c-27.965-4.106-74.658 5.136-120.434 18.629l11.623 28.874c41.917-17.79 83.212-31.283 108.811-31.283 38.83 0 78.776 23.483 108.707 51.835l.207-.026c-29.953-32.834-69.994-62.305-108.914-68.029z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.694 143.118c-18.671-2.742-45.694.47-75.216 6.922l9.603 23.856c25.737-8.863 48.987-14.558 65.613-14.558 32.339 0 65.454 16.289 92.914 38.112l2.386-.301c-27.914-26.877-62.018-49.136-95.3-54.031z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.132 354.465c-30.111 29.084-70.858 53.479-110.438 53.479-47.146 0-147.523-45.758-206.991-79.855-8.544-4.901-15.509-12.289-20.337-21.151-.88-1.617-1.687-3.284-2.432-5.002-3.285 8.135-5.08 16.907-5.08 25.729 0 10.793 2.693 20.727 7.512 28.882 4.828 8.155 11.793 14.522 20.337 18.16 59.469 25.365 159.845 56.38 206.991 49.457 39.58-5.821 80.327-36.199 110.438-69.699z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.946 374.365 15.347-38.127c60.186 32.796 148.926 71.706 192.401 71.706 39.58 0 80.327-24.395 110.438-53.479-30.111 33.5-70.858 63.878-110.438 69.699-47.146 6.922-147.523-24.092-206.991-49.457-.255-.109-.505-.228-.757-.342z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.677 357.47c54.363 26.299 116.749 50.474 151.017 50.474 39.58 0 80.327-24.395 110.438-53.479-30.111 33.5-70.858 63.878-110.438 69.699-37.159 5.456-107.381-12.655-164.583-32.992z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.694 424.164c-27.965 4.106-74.658-5.136-120.434-18.629l11.623-28.874c41.917 17.79 83.212 31.283 108.811 31.283 38.83 0 78.776-23.483 108.707-51.835l.207.026c-29.953 32.834-69.994 62.305-108.914 68.029z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.694 424.164c-18.671 2.742-45.694-.471-75.216-6.922l9.603-23.856c25.737 8.863 48.987 14.558 65.613 14.558 32.339 0 65.454-16.289 92.914-38.112l2.386.301c-27.914 26.877-62.018 49.136-95.3 54.031z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m510 283.641c0 39.924-80.838 131-157.305 131-47.148 0-147.523-45.762-206.991-79.867-17.086-9.799-27.852-29.545-27.852-51.136 0-21.592 10.768-41.339 27.856-51.137 59.469-34.099 159.841-79.859 206.988-79.859 76.466-.001 157.304 91.075 157.304 130.999z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 283.641c0 39.924-80.838 131-157.305 131-47.148 0-147.523-45.762-206.991-79.867-17.086-9.799-27.852-29.545-27.852-51.136 0-21.592 10.768-41.339 27.856-51.137 59.469-34.099 159.841-79.859 206.988-79.859 76.466-.001 157.304 91.075 157.304 130.999z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.695,
    cy: 253.496,
    fill: "url(#SVGID_13_)",
    r: 17.677
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.408 171.668c-19.889-10.783-38.294-18.567-65.611-19.027-47.146 0-147.523 45.758-206.991 79.855-11.21 6.437-19.314 17.149-23.559 29.862-3.626 10.833 2.28 22.768 12.296 25.406l73.371 19.292c48.438 12.733 99.407 1.526 140.028-30.812 8.455-6.73 15.204-15.563 19.826-25.628 4.631-10.065 7.144-21.364 7.144-33.025 0-21.07 17.259-36.775 35.559-32.368.574.141 1.131.202 1.66.202 6.991-.001 13.269-9.967 6.277-13.757zm-123.366 93.186c-26.27 0-47.568-14.289-47.568-31.924 0-17.634 21.298-31.934 47.568-31.934s47.568 14.3 47.568 31.934c0 17.635-21.298 31.924-47.568 31.924z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.951 284.536-89.339 62.519 59.327 66.801c4.203.513 8.137.785 11.755.785 33.962 0 68.78-17.97 97.001-41.44z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.293 312.836c0 13.623-5.688 26.454-15.354 34.641l-9.035 7.655c-13.164 11.153-29.944 15.416-46.086 11.708-16.217-3.725-29.499-16.842-34.803-34.496-3.817-12.703-5.752-25.672-5.752-38.46 0-14.705 2.561-29.174 7.762-42.721 5.877-15.315 21.234-20.012 34.636-10.598l50.514 35.494c11.27 7.92 18.118 21.821 18.118 36.777z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.95 308.735c0 8.499-5.67 16.503-15.306 21.611l-9.007 4.775c-13.124 6.958-29.851 9.617-45.944 7.304-16.167-2.324-29.408-10.507-34.695-21.52-3.805-7.925-5.734-16.016-5.734-23.993 0-9.174 2.553-18.2 7.738-26.652 5.859-9.554 21.169-12.484 34.529-6.612l50.358 22.143c11.234 4.941 18.061 13.613 18.061 22.944z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.573 305.221c0 4.11-5.651 7.98-15.254 10.45l-8.977 2.309c-13.079 3.364-29.75 4.65-45.787 3.532-16.112-1.124-29.308-5.081-34.577-10.406-3.792-3.832-5.714-7.744-5.714-11.602 0-4.436 2.545-8.801 7.711-12.887 5.839-4.62 21.097-6.037 34.411-3.197l50.187 10.707c11.197 2.389 18 6.582 18 11.094z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m301.162 236.054c-9.414 1.429-17.582 7.362-21.862 17.095-6.2 14.095-9.492 29.076-9.969 44.333.328 11.617 2.225 23.348 5.684 34.861 5.304 17.653 18.586 30.77 34.803 34.495.07.016.14.032.21.048 11.589 2.612 23.043-5.217 26.617-17.902 4.032-14.31 8.646-33.905 8.646-46.986 0-.744-.016-1.53-.046-2.351-.833-22.943-11.92-43.861-29.221-56.018l-4.363-3.066c-3.436-2.412-6.999-3.891-10.499-4.509z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.025 251.163c-5.2 13.547-7.762 28.016-7.762 42.721 0 12.788 1.935 25.757 5.752 38.46 2.914 9.697 8.234 18.025 15.126 24.18 9.614 8.585 23.842 4.546 28.64-8.171 5.87-15.56 9.273-34.059 9.273-53.907 0-11.859-1.216-23.236-3.447-33.792-1.766-8.355-6.475-15.543-12.946-20.09-13.402-9.413-28.759-4.716-34.636 10.599z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.001 270.259c-4.888 7.968-7.435 16.447-7.71 25.079.025 2.202.108 4.407.247 6.616.639 6.329 2.454 12.69 5.459 18.95 5.288 11.013 18.528 19.196 34.696 21.52 3.614.519 7.259.775 10.889.8 4.755-14.434 7.471-31.065 7.471-48.779 0-8.387-.62-16.524-1.765-24.309l-14.759-6.49c-13.36-5.871-28.669-2.941-34.528 6.613z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.974 286.616c-4.658 3.684-7.178 7.595-7.63 11.58.042 1.248.114 2.498.193 3.748.637 3.06 2.446 6.135 5.44 9.161 5.27 5.325 18.465 9.282 34.577 10.406 5.401.377 10.872.474 16.256.318 1.456-8.705 2.242-17.887 2.242-27.384 0-2.528-.067-5.028-.175-7.508l-16.492-3.519c-13.314-2.838-28.572-1.421-34.411 3.198z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.83 199.45c-7.369 0-14.431 1.869-20.964 5.293-5.373 2.815-5.347 6.322-2.694 10.975 1.54 2.701.986 5.659 2.324 8.847 6.48 15.428 10.451 36.213 10.451 59.077 0 22.792-3.946 43.518-10.389 58.931-1.356 3.243-.822 6.25-2.385 8.993-2.653 4.653-2.679 8.16 2.694 10.975 6.533 3.423 13.595 5.293 20.964 5.293 21.152 0 68.189-35.518 94.142-63.661 5.626-6.101 10.133-12.63 10.133-20.188 0-7.418-5.117-14.429-10.608-20.436-25.88-28.309-72.435-64.099-93.668-64.099z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.096 283.641c-.088-3.509-2.976-6.932-8.382-9.775-25.878-13.608-74.65-31.658-95.884-31.658-1.746 0-3.474.051-5.181.151-5.26.308-9.005 5.805-8.049 11.637 1.515 9.242 2.347 19.223 2.347 29.645s-.831 20.403-2.347 29.645c-.956 5.832 2.789 11.329 8.049 11.637 1.708.1 3.436.151 5.181.151 21.152 0 69.631-17.643 95.585-31.171 5.597-2.918 8.655-6.428 8.687-10.041-.001-.074-.005-.148-.006-.221z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.299 288.172c6.293-1.284 9.74-2.827 9.8-4.417-.001-.032-.002-.064-.002-.096 0-.006-.001-.012-.001-.018-.099-1.549-3.358-3.061-9.459-4.316-25.887-5.326-72.059-12.19-98.9-13.68-4.022-.223-7.294 3.537-7.054 8.064.173 3.257.264 6.57.264 9.932 0 3.364-.091 6.678-.264 9.937-.24 4.524 3.028 8.284 7.048 8.064 26.723-1.461 72.617-8.177 98.568-13.47z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.522 224.662c.116-.048.224-.099.343-.145 6.533-2.502 13.595-3.868 20.964-3.868 21.234 0 70.006 27.442 95.884 48.131 5.406 4.322 8.294 9.527 8.382 14.861-.088-7.299-2.976-14.42-8.382-20.334-25.878-28.308-74.65-65.857-95.884-65.857-7.369 0-14.431 1.869-20.964 5.293-5.373 2.816-7.347 8.322-4.694 12.975 1.553 2.723 3.003 5.726 4.351 8.944z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.414 299.242c-25.954 20.568-74.432 47.39-95.585 47.39-7.369 0-14.431-1.366-20.964-3.868-.119-.046-.228-.097-.344-.145-1.348 3.218-2.798 6.221-4.351 8.945-2.653 4.653-.679 10.159 4.694 12.975 6.533 3.423 13.595 5.293 20.964 5.293 21.152 0 69.631-36.701 95.585-64.844 5.626-6.101 8.69-13.448 8.69-21.005 0-.018-.001-.036-.001-.054-.013 5.51-3.074 10.865-8.688 15.313z",
    fill: "url(#SVGID_27_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 462.707,
    cy: 152.33,
    fill: "url(#SVGID_28_)",
    r: 28.125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.695,
    cy: 203.311,
    fill: "url(#SVGID_29_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.695,
    cy: 101.158,
    fill: "url(#SVGID_30_)",
    r: 16.305
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFish);
export default __webpack_public_path__ + "static/media/icon-fish.3e05dc6f77451dd03ac49acecb30733f.svg";
export { ForwardRef as ReactComponent };